// import { __UrlParams } from "../core";

export enum eAPPSTATE {
  NOT_SET = "NOT_SET",
  INITIALIZE = "INITIALIZE",
  LOADING_PRELOADER = "LOADING_PRELOADER",
  LOADING_SCRIPTS = "LOADING_SCRIPTS",
  LOADING_SETTINGS = "LOADING_SETTINGS",
  LOADING_FONTS = "LOADING_FONTS",
  LOADING_FINAL = "LOADING_FINAL",
  RGS_LOGIN = "RGS_OPEN",
  RGS_INIT = "RGS_INIT",
  LOADING_ENDED = "LOADING_ENDED",
  ONBOARDING = "ONBOARDING",
  BEFORE_INGAME = "BEFORE_INGAME",
  INGAME = "INGAME",
  RESUME_AFTER_FREEROUNDS = "RESUME_AFTER_FREEROUNDS", // used ONLY for resume after FREE SPINS now
  STALL = "STALL", //used after loading errors
}

export const ENABLE_LOGGING = true;

const getParams = () => {
  let _params: any = [];
  new URL(window.location.href).searchParams.forEach(function (val, key) {
    _params[key] = decodeURIComponent(val);
  });
  return _params;
};

export let PROVIDER_URL = { MARLIPIN: "", BETDETAILS: "" };

function getProviderURL() {
  const endpoint = getParams().endpoint;
  let date = new Date();

  switch (endpoint) {
    case "dev.cbcontents.com":
      PROVIDER_URL.MARLIPIN =
        "https://demo.cbcontents.com/widget/game-wrapper/wrapper.js?v=" +
        date.getTime();
      PROVIDER_URL.BETDETAILS =
        "https://dev.cbcontents.com/marlipin/bets/betDetailsPlayer_v4.jsp";
      break;
    case "uat.cbcontents.com":
      PROVIDER_URL.MARLIPIN =
        "https://demo-uat.cbcontents.com/widget/game-wrapper/wrapper.js?v=" +
        date.getTime();
      PROVIDER_URL.BETDETAILS =
        "https://uat.cbcontents.com/marlipin/bets/betDetailsPlayer_v4.jsp";
      break;
    case "prod1.cbcontents.com":
      PROVIDER_URL.MARLIPIN =
        "https://fe.cbcontents.com/game-wrapper/wrapper.js?v=" + date.getTime();
      PROVIDER_URL.BETDETAILS =
        "https://prod1.cbcontents.com/marlipin/bets/betDetailsPlayer_v4.jsp";
      break;
    case "prod.cbcontents.com":
      PROVIDER_URL.MARLIPIN =
        "https://fe.cbcontents.com/game-wrapper/wrapper.js?v=" + date.getTime();
      PROVIDER_URL.BETDETAILS =
        "https://prod1.cbcontents.com/marlipin/bets/betDetailsPlayer_v4.jsp";
      break;
    default:
      PROVIDER_URL.MARLIPIN =
        "https://demo.cbcontents.com/widget/game-wrapper/wrapper.js?v=" +
        date.getTime();
      PROVIDER_URL.BETDETAILS =
        "https://dev.cbcontents.com/marlipin/bets/betDetailsPlayer_v4.jsp";
  }
}
getProviderURL();

export const AVAILABLE_RESOLUTIONS = {
  DESKTOP: {
    width: 992,
  },
  TABLET: {
    width: 768,
  },
  MOBILE: {
    width: 479,
  },
};

export const TRANSLATE_TOOL_URL = "https://admin.cbcontents.com/api/";
